module.exports = __webpack_public_path__ + "img/password.23b54614.svg";